import { render } from "./rph-settings-notifications-and-ui.vue?vue&type=template&id=5c28a975"
import script from "./rph-settings-notifications-and-ui.vue?vue&type=script&lang=js"
export * from "./rph-settings-notifications-and-ui.vue?vue&type=script&lang=js"
script.render = render

export default script